import { render, staticRenderFns } from "./WillOtherPropertiesFriendsContinueYN.vue?vue&type=template&id=64b987e0"
import script from "./WillOtherPropertiesFriendsContinueYN.vue?vue&type=script&lang=js"
export * from "./WillOtherPropertiesFriendsContinueYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports